import React, { useState, useEffect } from 'react';
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import PasswordChecklist from "react-password-checklist";

import DialogTitle from "../../../../Common/UI/Dialog/DialogTitle";
import Spinner from "../../../../Common/UI/Spinner/Spinner";
import { useNotification } from "../../../../../core/contexts/NotificationContext";
import * as UserApi from '../../../../Common/Apis/UserApi';

const PasswordReset = (props) => {
  const { isShow, item, onClose } = props;
  const { showSuccess, showWarning } = useNotification();

  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [userPassword, setUserPassword] = useState("");
  const [userConfirmPassword, setUserConfirmPassword] = useState("");
  const [userPasswordErr, setUserPasswordErr] = useState(false);

  const getAutoPassword = () => {
    const length = 12;
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_-+=";
    let newPassword = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      newPassword += charset[randomIndex];
    }
    setUserPassword(newPassword);
    setUserConfirmPassword(newPassword);
  };

  const setPasswordReset = async () => {
    if (userPasswordErr) {
      showWarning({ content: "Please input valid password", timeout: 3000 });
      return;
    }

    try {
      setIsLoading(true);
      await UserApi.UpdatePassword(item.UserId, { UserPassword: userPassword });
      showSuccess({ content: "Successfully saved", timeout: 3000 });
      onClose();
    } catch (err) {
      console.log("err", err);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    setUserPassword("");
    setUserConfirmPassword("");
    setUserPasswordErr(false);
  }, [item]);

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog"
        open={isShow}
        PaperProps={{ style: { borderRadius: "1rem", margin: 20 } }}
      >
        <DialogTitle id="customized-dialog-title" onClose={onClose}>
          Password Reset
        </DialogTitle>
        <MuiDialogContent dividers style={{ padding: 0 }}>
          <form>
            <div className="modal-content model-dialog">
              <div className="modal-body  pt-0 pb-0">
                <div className="row mt-3">
                  <div className="col-sm-6">
                    <div className="p-number">
                      <TextField
                        type={showPassword ? "text" : "password"}
                        style={{ width: "100%" }}
                        label=""
                        variant="outlined"
                        size="small"
                        onChange={(e) => setUserPassword(e.target.value)}
                        value={userPassword || ""}
                        helperText={""}
                      />
                    </div>
                    <span className="p-num-span mr-2">Password</span>
                  </div>
                  <div className="col-sm-6">
                    <div className="p-number">
                      <TextField
                        type={showPassword ? "text" : "password"}
                        style={{ width: "100%" }}
                        label=""
                        variant="outlined"
                        size="small"
                        onChange={(e) => setUserConfirmPassword(e.target.value)}
                        value={userConfirmPassword || ""}
                        helperText={""}
                      />
                    </div>
                    <span className="p-num-span mr-2">Confirm Password</span>
                  </div>
                  <div className="col-sm-6">
                    <div className="row">
                      <div className="col-6">
                        <div className="">
                          <Switch
                            checked={showPassword}
                            onChange={() => setShowPassword(!showPassword)}
                            color="primary"
                            name="chkEnabled"
                            inputProps={{ "aria-label": "primary checkbox" }}
                          />
                        </div>
                        <span className="p-num-span mr-2">Show Password</span>
                      </div>
                      <div className="col-6">
                        <Button
                          color="primary"
                          style={{ textTransform: "none" }}
                          onClick={getAutoPassword}
                          variant="text"
                        >
                          Generate Password
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <PasswordChecklist
                      style={{ background: "#f7f7f7" }}
                      rules={["minLength", "specialChar", "number", "match"]}
                      minLength={8}
                      value={userPassword}
                      valueAgain={userConfirmPassword}
                      onChange={(isValid) => setUserPasswordErr(!isValid)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </MuiDialogContent>
        <MuiDialogActions style={{ margin: 0, padding: 8 }}>
          <Button
            className="mb-3"
            style={{ fontWeight: "600" }}
            variant="contained"
            onClick={() => setPasswordReset()}
            color="primary"
          >
            Save
          </Button>
        </MuiDialogActions>
      </Dialog>
      {isLoading && <Spinner />}
    </>
  );
};

export default PasswordReset;
